import React, { Component } from "react";
import Weather from './weather'
import Countdown from './countdown'
import ClockTimeDate from './clock'
import QRCode from './qrcode'
import NoticeBoard from './noticeboard'
import MotivationalQuote from './motivationalQuote'
import Calendar from './calendar'
import LeaderBoard from './LeaderBoard'
import Polls from "./polls";

class AppContent extends Component {

    render() {
        const { id } = this.props;
        return <>
            {id && id == 1 && <Weather {...this.props} />}
            {id && id == 4 && <QRCode {...this.props} />}
            {id && id == 2 && <Calendar {...this.props} />}
            {id && id == 5 && <Countdown {...this.props} />}
            {id && id == 3 && <ClockTimeDate {...this.props} />}
            {id && id == 9 && <NoticeBoard {...this.props} />}
            {id && id == 8 && <MotivationalQuote {...this.props} />}
            {id && id == 11 && <Polls {...this.props} />}

            {this.props.match && id && id == 10 &&
                <LeaderBoard {...this.props} />
            }

        </>
    }
}
export default AppContent;
